<template>
  <div class="info">
    <p
      v-for="(item, index) of items"
      :key="index"
      class="row"
    >
      <span class="key">
        {{ item.key }}:
      </span>
      <span class="value">
        {{ item.value }}
      </span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'AppInformation',
  data () {
    return {
      mail: '',
      location: '',
      position: '',
      gender: '',
      height: '',
      weight: '',
      birthday: '',
      matchesPlayed: '',
      matchesMiss: ''
    }
  },
  computed: {
    items () {
      return [
        { key: 'Почта', value: this.mail },
        { key: 'Местоположение', value: this.location },
        { key: 'Позиция', value: this.position },
        { key: 'Пол', value: this.gender },
        { key: 'Рост', value: this.height },
        { key: 'Вес', value: this.weight },
        { key: 'Дата рождения', value: this.birthday },
        { key: 'Сыграно матчей', value: this.matchesPlayed },
        { key: 'Не пришел на игру', value: this.matchesMiss }
      ]
    }
  },
  created () {
    this.fetchUserData()
  },
  methods: {
    /**
     * TODO
     * Перепроверить!!!
     * TODO
     */
    async fetchUserData () {
      try {
        const placeholder = 'Нет данных.'
        const { data } = await this.$api.user.user(this.$route.params.id)

        this.mail = data?.email ?? placeholder
        this.location = data?.address ?? placeholder
        this.position = data?.position ?? placeholder
        this.gender = data?.gender.label ?? placeholder
        this.height = data?.height ?? placeholder
        this.weight = data?.weight ?? placeholder
        this.birthday = data?.birthday ?? placeholder
        this.matchesPlayed = data?.matchesPlayed ?? placeholder
        this.matchesMiss = data?.wasNotPresentGame ?? placeholder
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.info {
  .row {
    font-weight: bold;
    font-size: 16px;
    line-height: 1.8;
    letter-spacing: 0.2px;

    .key {
      color: #AFAFB6;
    }
    .value {
      color: #fff;
    }
  }
}
</style>
